export const PRODUCT_BROADBAND = 'broadband';
export const PRODUCT_CAR_INSURANCE = 'car_insurance';
export const PRODUCT_CREDIT_CARDS = 'cards';
export const PRODUCT_CURRENT_ACCOUNTS = 'currents';
export const PRODUCT_ENERGY = 'energy';
export const PRODUCT_HOME_INSURANCE = 'home_insurance';
export const PRODUCT_INCOME_PROTECTION = 'income_protection';
export const PRODUCT_LIFE_INSURANCE = 'life_insurance';
export const PRODUCT_LOANS = 'loans';
export const PRODUCT_MORTGAGE_PROTECTION = 'mortgage_protection';
export const PRODUCT_MORTGAGES = 'mortgages';
export const PRODUCT_PREPAY_CARDS = 'prepay_cards';
export const PRODUCT_SAVINGS_ACCOUNTS = 'savings';
export const PRODUCT_SERIOUS_ILLNESS = 'serious_illness';
